'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fsts = require('fsts');

var _Empty = require('./Empty');

var _Empty2 = _interopRequireDefault(_Empty);

var _MatchMedia = require('./MatchMedia');

var _MatchMedia2 = _interopRequireDefault(_MatchMedia);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _instance = new _MatchMedia2.default();

exports.default = _instance;


/*****************
 ** WEBPACK FOOTER
 ** ./~/fluid-react/dist/media/index.js
 ** module id = 135
 ** module chunks = 0
 **/